export default "__VITE_ASSET__VL9z9aS2__"